import base from '@/__vue2stone/service/wasaapi/v1/__base';
import time from '@/service/base/time';
import store from '@/store';
import moment from 'moment';
import i18n from '@/i18n';

export default {
  async factoryIndex(factoryId, params) {
    //取得factory checklist record內容
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'checklist_record',
      params: _params,
      pagination: true,
    });
    return res;
  },
  async index(checklistId, params) {
    //取得 checklist record in  checklist
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.index({
      parentName: 'checklist',
      parentId: checklistId,
      modelName: 'checklist_record',
      params: _params,
      pagination: true,
    });
    return res;
  },
  async create(checklistId, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.create({
      parentName: 'checklist',
      parentId: checklistId,
      modelName: 'checklist_record',
      data: _data,
    });
    return res;
  },
  async show(recordId, factoryId, parentFactoryId, params) {
    const _params = {
      factory: factoryId ? factoryId : store.state.app.factory.id,
      ...params,
    };
    if (parentFactoryId) {
      _params.organization = parentFactoryId;
    }
    const res = await base.show({
      modelName: 'v2/checklist_record',
      modelId: recordId,
      params: _params,
    });
    return res;
  },
  async updateReviewRemark(recordId, data) {
    //create record
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.update({
      parentName: 'checklist_record',
      parentId: recordId,
      modelName: 'review_remark',
      data: _data,
    });
    return res;
  },
  getRecordData(record) {
    return {
      title: record.name,
      reviewer: record.reviewer,
      checker: record.checker,
      recordAt: this.getTimeFormat(record.created_at),
      reviewAt: this.getTimeFormat(record.review_at),
      images: record.images,
      reviewRemark: record.review_remark,
      systemClasses: record.system_classes,
      systemSubclasses: record.system_subclasses,
      questions: record.questions,
      checklistId: record.checklist ? record.checklist.id : null,
      frequency: record.frequency,
      alert: record.alert,
      tasks: record.tasks,
      reviewRecords: record.checklist_review_records.map(record => {
        const {content, id, recorder, score} = record
        return {
          content,
          id,
          recorder,
          score,
          fileVersions: record.file_versions,
          recordAt: time.getTimeFormat(record.record_at, 'YYYY-MM-DD HH:mm:ss'),
        }
      }),
      sampleRecords: record.checklist_sample_records.map(record => {
        const {content, id, recorder, score} = record
        return {
          content,
          id,
          recorder,
          score,
          fileVersions: record.file_versions,
          recordAt: time.getTimeFormat(record.record_at, 'YYYY-MM-DD HH:mm:ss'),
        }
      }),
      reviewers: record.checklist.reviewers ? record.checklist.reviewers : [],
    };
  },
  async answerIndex(recordId, factoryId, parentFactoryId,  params) {
    const _params = {
      factory: factoryId ? factoryId : store.state.app.factory.id,
      order_way: 'asc',
      order_by: 'sequence',
      ...params,
    };
    if (parentFactoryId) {
      _params.organization = parentFactoryId;
    }
    const res = await base.index({
      parentName: 'v2/checklist_record',
      parentId: recordId,
      modelName: 'checklist_record_answer',
      params: _params,
    });
    return res;
  },
  getRecordAnswers(answers) {
    const _answers = answers.map((answer) => {
      return {
        article_versions: answer.article_versions,
        act_versions: answer.act_versions,
        act_version_alls: answer.act_version_alls,
        checklistQuestion: answer.checklist_question
          ? { id: answer.checklist_question.id }
          : null,
        checklistQuestionTemplate: answer.checklist_question_template
          ? { id: answer.checklist_question_template.id }
          : null,
        id: answer.id,
        remark: answer.remark,
        score: answer.score,
        riskLevel: answer.risk_level,
        questionId: answer.checklist_question.id,
        acts: answer.act_version_alls,
        articles: answer.article_versions,
        riskSignal: answer.effects,
        quesType: answer.question_type,
        controlLimitData: {
          upper: answer.control_limit_upper
            ? answer.control_limit_upper.toString()
            : null,
          lower: answer.control_limit_lower
            ? answer.control_limit_lower.toString()
            : null,
        },
        specLimitData: {
          upper: answer.spec_limit_upper
            ? answer.spec_limit_upper.toString()
            : null,
          lower: answer.spec_limit_lower
            ? answer.spec_limit_lower.toString()
            : null,
        },
        ocapRemark: answer.ocap_remark,
        ocapAttaches: answer.ocap_attaches,
        attaches: answer.checklist_question_template
          ? answer.question_template_attaches
          : answer.question_attaches,
        images: answer.images,
        title: answer.title,
        subtitle: answer.checklist_question_template ? '建議題目' : '自訂題目',
        questionRemark: answer.question_remark,
        type: answer.checklist_question_template ? 'template' : 'custom',
      };
    });
    return _answers;
  },
  getTimeFormat(date) {
    return moment(date).format('YYYY-MM-DD HH:mm:ss');
  },
  getDateFormat(date) {
    return time.getTimeFormat(date, 'YYYY-MM-DD');
  },
  getChecklistData(data, user) {
    const _data = {
      id: data.id,
      versionId: data.last_version.id,
      name: data.name,
      checker: user,
      checkers: [user],
      checkersValue: data.checkers,
      reviewer: data.reviewers ? data.reviewers : null,
      reviewers: data.reviewers ? data.reviewers : [],
      reviewerValue: data.reviewers ? data.reviewers : [],
      timely: data.frequency,
      remindDate: data.expired_before_days
        ? data.expired_before_days.toString()
        : null,
      template: {
        id: data.checklist_template ? data.checklist_template.id : null,
        name: null,
        versionId: null,
        lastVersionId: null,
      },
      systemSubclasses: data.system_subclasses,
      systemClasses: data.system_classes,
    };
    return _data;
  },
  getAssignSelectQues(templateIds, questions) {
    const _questions = questions.filter((question) => {
      return (
        !question.templateId ||
        (question.templateId && templateIds.includes(question.templateId))
      );
    });
    return _questions;
  },
  getChapters(questions) {
    //用於assignment
    const _questions = this.getAssignmentQuesResult(questions);
    return [
      {
        sectionList: [
          {
            questionList: _questions,
          },
        ],
      },
    ];
  },
  getAssignmentQuesData(questions) {
    const assignmentQues = [];
    const _questions = JSON.parse(JSON.stringify(questions));
    _questions.forEach((question) => {
      let ques = {
        question: question,
        answer: {
          value: '',
          score: null,
          images: [],
          remark: '',
        },
      };
      assignmentQues.push(ques);
    });
    return assignmentQues;
  },
  getAllQuesResult(chapters) {
    //從章節中取得所有題目
    const allQues = [];
    chapters.forEach((chapter) => {
      chapter.sectionList.forEach((section) => {
        section.questionList.forEach((question) => {
          allQues.push(question);
        });
      });
    });
    return allQues;
  },
  getChapterRiskSort(riskSort, questions) {
    //依照risk排序
    const _riskSort = riskSort.map((sort) => {
      sort.questionList = questions.filter((question) => {
        if (question.quesType === 2) {
          return question.score === sort.score;
        } else if (question.quesType === 1) {
          let resultScore = this.getQuantDataScore(question, question.score);
          return resultScore === sort.score;
        }
      });
      return sort;
    });
    return _riskSort;
  },
  getAssignmentQuesResult(questions) {
    const _questions = questions.map((item) => {
      let _item = {
        ...item.question,
        ...item.answer,
      };
      _item.riskLevel =
        _item.quesType === 2
          ? _item.score
          : this.getQuantDataScore(_item, _item.score);
      _item.score = parseFloat(_item.score);
      return _item;
    });
    return _questions;
  },
  getQuantDataScore(question, score) {
    if (!question.controlLimitData || !question.specLimitData) {
      return 20;
    }
    if (!score && !score === 0) {
      return null;
    }
    const upperMiddle =
      (parseFloat(question.controlLimitData.upper) +
        parseFloat(question.specLimitData.upper)) /
      2;
    const lowerMiddle =
      (parseFloat(question.controlLimitData.lower) +
        parseFloat(question.specLimitData.lower)) /
      2;
    if (
      parseFloat(question.controlLimitData.lower) <= parseFloat(score) &&
      parseFloat(score) <= parseFloat(question.controlLimitData.upper)
    ) {
      return 25;
    } else {
      if (parseFloat(score) > upperMiddle || parseFloat(score) < lowerMiddle) {
        return 23;
      }
      if (
        (lowerMiddle <= parseFloat(score) &&
          parseFloat(score) < question.controlLimitData.lower) ||
        (question.controlLimitData.upper < parseFloat(score) &&
          parseFloat(score) <= upperMiddle)
      ) {
        return 22;
      } else {
        return null;
      }
    }
  },
  getQuesWithAnswer(questions, answers) {
    if (questions.length === 0 || answers.length === 0) return [];
    const _questions = questions.map((question) => {
      const answer = answers.find(
        (answer) => answer.checklistQuestion.id === question.id,
      );
      let _question = {
        ...question,
        ...answer,
      };
      return _question;
    });
    return _questions;
  },
  getRecordChapters(questions, sortQues) {
    //用於result,review
    const _questions = this.getRecordQuesResult(questions, sortQues);
    return [
      {
        sectionList: [
          {
            questionList: _questions,
          },
        ],
      },
    ];
  },
  getRecordQuesResult(questions, sortQues) {
    //用於result,review
    if (
      !questions ||
      !sortQues ||
      questions.length === 0 ||
      sortQues.length === 0
    )
      return [];
    let _questions = sortQues
      .map((sort) => {
        const question = questions.find(
          (question) => question.checklistQuestion.id === sort.id,
        );
        if (!question) return;
        question.riskLevel =
          question.quesType === 2
            ? question.score
            : this.getQuantDataScore(question, question.score);
        return question;
      })
      .filter((ques) => ques);
    return _questions;
  },
  getCustomedIndex(list) {
    let _list = JSON.parse(JSON.stringify(list));
    _list.forEach((chapter) => {
      chapter.sectionList.forEach((section) => {
        section.questionList.forEach((question) => {
          const qIndex = section.questionList.indexOf(question) + 1;
          question.questionCustomedIndex = `${qIndex}` + '.';
        });
      });
    });
    return _list;
  },
  getPassRate(answers) {
    if (!answers || answers.length === 0) return 0;
    const passNum = answers.filter(
      (answer) => parseInt(answer.riskLevel) === 25,
    ).length;
    const quesNum = answers.filter(
      (answer) => parseInt(answer.riskLevel) !== 20,
    ).length;
    const passRate = (passNum / quesNum) * 100;
    return passRate.toFixed(2);
  },
  getRiskLevel(answers) {
    const allRiskLevel = answers.map((answer) => parseInt(answer.riskLevel));
    if (allRiskLevel.includes(23)) {
      return 23;
    } else if (allRiskLevel.includes(22)) {
      return 22;
    } else if (allRiskLevel.includes(21)) {
      return 21;
    } else {
      return 25;
    }
  },
  getQuesSort(questions) {
    const _questions = questions.map((question) => {
      return {
        id: question.id,
        type: question.templateId ? 'template' : 'custom',
      };
    });
    return _questions;
  },
  //記錄列表 - 產生日期列表
  setDateByFrequency(selectDate, frequency, seasons) {
    const dateList = [];
    const startDate = selectDate.start;
    const endDate = selectDate.end;
    if (frequency === 'day' || frequency === 'everyTime') {
      dateList.push(moment(endDate).format('YYYY-MM-DD'));
      if (startDate) {
        var i = 1;
        let nextDate = endDate;
        while (moment(nextDate).isAfter(startDate)) {
          nextDate = moment(nextDate)
            .subtract(i, 'day')
            .format('YYYY-MM-DD');
          dateList.push(nextDate);
        }
      }
    } else if (frequency === 'week' || frequency === 'month') {
      const start = moment(startDate).startOf(frequency);
      const end = moment(endDate).endOf(frequency);
      const diff = end.diff(start, `${frequency}s`);
      for (let i = 0; i < diff; i++) {
        const date = moment(end).subtract(i, `${frequency}s`);
        dateList.push(moment(date).format('YYYY-MM-DD'));
      }
    } else if (frequency === 'season') {
      //get month,seasons
      const startDateMonth = time.getDateMonth(startDate);
      const endDateMonth = time.getDateMonth(endDate);
      const startDateSeasons = seasons.find((season) =>
        season.seasonMonths.includes(parseInt(startDateMonth)),
      ).seasonMonths;
      const endDateSeasons = seasons.find((item) =>
        item.seasonMonths.includes(parseInt(endDateMonth)),
      ).seasonMonths;
      //get season start date
      const start = time.getSeasonStartDate(
        startDate,
        startDateMonth,
        startDateSeasons,
      );
      const end = time.getSeasonStartDate(
        endDate,
        endDateMonth,
        endDateSeasons,
      );
      const diffSeasons = moment(end).diff(start, 'months') / 3;
      for (let i = 0; i <= diffSeasons; i++) {
        const date = moment(end).subtract(i * 3, 'months');
        dateList.push(moment(date).format('YYYY-MM-DD'));
      }
    } else if (frequency === 'year') {
      const start = moment(startDate).startOf('year');
      const end = moment(endDate).endOf('year');
      const diff = end.diff(start, 'years');
      if (diff === 0) {
        dateList.push(moment(end).format('YYYY-MM-DD'));
      } else {
        for (let i = 0; i <= diff; i++) {
          const date = moment(end).subtract(i, 'years');
          dateList.push(moment(date).format('YYYY-MM-DD'));
        }
      }
    }
    return dateList;
  },
  //記錄列表 - 日
  getDayRecordList(
    dateList,
    systemList,
    recordList,
    checklistList,
    recordHeader,
    checklistHeader,
    type,
  ) {
    let allClass = JSON.parse(JSON.stringify(systemList));
    let listWithSystemclass = [];
    if (dateList && dateList.length > 0 && allClass) {
      dateList.forEach((date) => {
        let num = 1;
        allClass.forEach((systemclassItem) => {
          let _item = {
            date: num === 1 ? date : '',
            systemClassIcon: systemclassItem.icon,
            systemClass: systemclassItem.name,
            systemClassId: systemclassItem.id,
            recordDataTable: {
              columnHeader: recordHeader,
            },
            unRecordDataTable: {
              columnHeader: checklistHeader,
            },
          };
          const _recordList = this.getRecordListByDate(
            type,
            date,
            systemclassItem.id,
            recordList,
          );
          _item.recordDataTable.rowData = this.getRecordListData(_recordList);
          let _unrecordList = []
          _item.unRecordDataTable.rowData = []
          if (type !== "everyTime") {
            _unrecordList = this.getUnrecordChecklists(
              checklistList,
              systemclassItem.id,
              _recordList,
            );
            _item.unRecordDataTable.rowData = this.getUnrecordChecklistData(
              _unrecordList,
            );
          }
          if (_recordList.length || _unrecordList.length) {
            listWithSystemclass.push(_item);
            num++;
          }
        });
      });
    }
    return listWithSystemclass;
  },
  getUnrecordChecklists(checklists, systemClassId, records) {
    const recordChecklistIds = records
      ? records.map((record) => record.checklist.id)
      : [];
    const unrecordList = checklists.filter((checklist) => {
      return (
        checklist.system_class_ids.includes(systemClassId) &&
        !recordChecklistIds.includes(checklist.id)
      );
    });
    return unrecordList;
  },
  getRecordListByDate(type, startDate, systemClassId, records) {
    if (!records) {
      return [];
    }
    if (type === 'day' || type === 'everyTime') {
      const recordList = records.filter((record) => {
        const systemClassIds = record.system_classes.map((item) => item.id);
        return (
          systemClassIds.includes(systemClassId) &&
          moment(record.record_at).format('YYYY-MM-DD') === startDate
        );
      });
      return recordList;
    } else if (type === 'week' || type === 'month' || type === 'year') {
      const recordList = records.filter((record) => {
        const systemClassIds = record.system_classes.map((item) => item.id);
        return (
          systemClassIds.includes(systemClassId) &&
          moment(record.record_at).isSame(startDate, type)
        );
      });
      return recordList;
    } else if (type === 'season') {
      const endDate = moment(startDate)
        .add(2, 'months')
        .format('YYYY-MM-DD');
      const recordList = records.filter((record) => {
        const systemClassIds = record.system_classes.map((item) => item.id);
        return (
          systemClassIds.includes(systemClassId) &&
          moment(record.record_at).isBetween(startDate, endDate)
        );
      });
      return recordList;
    }
  },
  getUnrecordChecklistData(checklists) {
    const list = checklists.map((checklist) => {
      const _checker = checklist.checkers.map((item) => item.name).toString();
      return {
        id: checklist.id,
        subCategory: checklist.system_subclasses.map((item) => {
          return {
            name: item.name,
            leadingIcon: item.icon,
          };
        }),
        name: checklist.name,
        checker: _checker,
      };
    });
    return list;
  },
  getRecordListData(records) {
    const list = records.map((record) => {
      const riskLevelList = store.state.model.checklistRiskLevelList.filter(risk => risk.type == 'result');
      const tarRiskLevel = riskLevelList.find(
        (risk) => risk.score === record.risk_level,
      )
      return {
        id: record.id,
        result: {
          icon: tarRiskLevel.icon,
          color: tarRiskLevel.color,
        },
        classification: record.system_classes
          .map((item) => item.name)
          .join('、'),
        subCategory: record.system_subclasses.map((item) => {
          return {
            name: item.name,
            leadingIcon: item.icon,
          };
        }),
        name: record.name,
        compliance: record.pass_rate + '%',
        checker: record.checker
          ? record.checker.name
          : "",
        reviewer: record.reviewer
        ? record.reviewer.name
        : "",
        date: moment(record.record_at).format('YYYY-MM-DD'),
        condition: record.review_at ? '已覆核' : '尚未覆核',
        download: [
          {
            text: `${i18n.t('匯出')} xlsx`,
            value: 'xlsx',
            id: record.id,
          },
          {
            text: `${i18n.t('匯出')} csv`,
            value: 'csv',
            id: 3,
          },
          {
            text: `${i18n.t('匯出與列印')}`,
            value: 'print',
            id: 4,
          },
        ],
        sample: {
          text: i18n.t("抽檢")
        }
      };
    });
    return list;
  },
  async getChapterList(recordId) {
    let res = await this.answerIndex(recordId);
    const recordAnswer = this.getRecordAnswers(res);
    res = await this.show(recordId);
    const record = this.getRecordData(res);
    const chapters = this.getRecordChapters(recordAnswer, record.questions);
    const listWithIndex = this.getCustomedIndex(chapters);
    return listWithIndex;
  },
  getSampleRecordList(list) {
    const resultArr = list.map((record) => {
      const result = record.score === 10
        ? {
            text: i18n.t("通過"),
            color: "green",
          }
        : {
            text: i18n.t("不通過"),
            color: "red",
          }
      return {
        id: record.id,
        recordAt: this.getDateFormat(record.record_at),
        recorder: record.recorder.name,
        result,
      };
    });
    return resultArr;
  },
  async sampleRecordIndex(checklistId, params) {
    const currentFactoryId = store.state.app.factory.id;
    const url = `v1/factory/${currentFactoryId}/checklist/${checklistId}`
    const _params = {
      factory: currentFactoryId,
      ...params,
    };
    const res = await base.index({
      url,
      params: _params,
      pagination: true,
    });
    return res;
  },
  async analysisIndex(params) {
    const currentFactoryId = store.state.app.factory.id;
    const _params = {
      factory: currentFactoryId,
      ...params,
    };
    const res = await base.show({
      parentName: 'factory',
      parentId: currentFactoryId,
      modelName: 'checklist_record/analysis/index',
      params: _params,
    });
    return res;
  },
  async showAnswer(recordId) {
    const res = await base.show({
      modelName: 'v2/checklist_record_answer',
      modelId: recordId,
    });
    return res;
  },
  async update(recordId, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.update({
      modelName: 'checklist_record',
      modelId: recordId,
      data: _data,
    });
    return res;
  },
  async dropChecklist(recordId, data) {
    const res = await base.put({
      parentName: 'checklist_record',
      parentId: recordId,
      modelName: 'no_checklist',
      data,
    });
    return res;
  },
  async complete(recordId) {
    const res = await base.update({
      parentName: 'checklist_record',
      parentId: recordId,
      modelName: 'complete',
      data: {
        factory: store.state.app.factory.id,
      },
    });
    return res;
  },
};
